import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isPitchTechPage = location.pathname === '/pitch-tech';

  useEffect(() => {
    // Close mobile menu when route changes
    setIsMenuOpen(false);
  }, [location]);

  useEffect(() => {
    // Update navbar collapse class
    if (window.jQuery) {
      window.jQuery(document).ready(function($) {
        const navbar = $('.navbar-collapse');
        if (isMenuOpen) {
          navbar.addClass('show');
        } else {
          navbar.removeClass('show');
        }
      });
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`main-header header-three ${isPitchTechPage ? 'pitch-tech-header' : ''}`} style={isPitchTechPage ? {
      background: 'rgba(28, 41, 56, 0.1)',
      backdropFilter: 'blur(10px)',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      width: '100%',
      transition: 'all 0.3s'
    } : {}}>
      <div className="header-upper" style={isPitchTechPage ? {
        background: 'transparent',
        paddingTop: '15px',
        paddingBottom: '15px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
      } : {}}>
        <div className="container clearfix">
          <div className="header-inner" style={isPitchTechPage ? {
            paddingTop: '10px',
            paddingBottom: '10px'
          } : {
            paddingTop: '20px',
            paddingBottom: '20px'
          }}>
            <div className="logo-outer">
              <div className="logo">
                <Link to="/">
                  <img src="/assets/images/logos/logo.png" alt="Logo" style={isPitchTechPage ? {
                    height: 'auto',
                    width: '120px',
                    maxHeight: '60px',
                    objectFit: 'contain',
                    filter: 'brightness(0) invert(1)'
                  } : {
                    height: 'auto',
                    width: '100px',
                    maxHeight: '79px',
                    objectFit: 'contain'
                  }} />
                </Link>
              </div>
            </div>
            <div className="nav-outer d-flex align-items-center clearfix mx-lg-auto flex-grow-1">
              <nav className="main-menu navbar-expand-lg w-100">
                <div className="navbar-header">
                  <div className="logo-mobile">
                    <Link to="/">
                      <img src="/assets/images/logos/logo.png" alt="Logo" style={isPitchTechPage ? {
                        height: 'auto',
                        width: '120px',
                        maxHeight: '60px',
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)'
                      } : {
                        height: '79px',
                        width: '100px'
                      }} />
                    </Link>
                  </div>
                  <button 
                    type="button" 
                    className="navbar-toggle" 
                    onClick={toggleMenu}
                    aria-controls="main-menu"
                    style={isPitchTechPage ? {
                      borderColor: 'white'
                    } : {}}
                  >
                    <span className="icon-bar" style={isPitchTechPage ? {background: 'white'} : {}}></span>
                    <span className="icon-bar" style={isPitchTechPage ? {background: 'white'} : {}}></span>
                    <span className="icon-bar" style={isPitchTechPage ? {background: 'white'} : {}}></span>
                  </button>
                </div>
                <div className={`navbar-collapse collapse clearfix ${isMenuOpen ? 'show' : ''}`} id="main-menu" style={isPitchTechPage ? {
                  background: 'rgba(28, 41, 56, 0.95)',
                  borderRadius: '10px',
                  padding: '15px',
                  marginTop: '10px'
                } : {}}>
                  <ul className="navigation clearfix" style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    listStyle: 'none',
                    margin: 0,
                    padding: 0
                  }}>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/" style={isPitchTechPage ? {color: 'white'} : {}}>Home</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/about" style={isPitchTechPage ? {color: 'white'} : {}}>About Us</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/features" style={isPitchTechPage ? {color: 'white'} : {}}>Features</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/solutions" style={isPitchTechPage ? {color: 'white'} : {}}>Solutions</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/blog" style={isPitchTechPage ? {color: 'white'} : {}}>Blog</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/pricing" style={isPitchTechPage ? {color: 'white'} : {}}>Pricing</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/become-partner" style={isPitchTechPage ? {color: 'white'} : {}}>Become A Partner</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/contact" style={isPitchTechPage ? {color: 'white'} : {}}>Contact Us</Link>
                    </li>
                    <li style={{whiteSpace: 'nowrap'}}>
                      <Link to="/pitch-tech" style={isPitchTechPage ? {color: 'white'} : {}}>Pitch Tech</Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
            <div className="menu-right d-none d-lg-flex align-items-center">
              <Link to="/contact" className="theme-btn style-two" style={isPitchTechPage ? {
                padding: '8px 16px',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                background: 'white',
                color: '#4A90E2'
              } : {
                padding: '8px 16px',
                fontSize: '14px',
                whiteSpace: 'nowrap'
              }}>
                Get Demo<i className="fas fa-arrow-right ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

